import React from 'react';
import { RightContainer } from "../ConfirmedOffer.styles";
import { Value, ValueBox, ShiftBoxRateDescription, DateTimeDescription } from "../ConfirmedOffer.styles";
import DateRangeOutlinedIcon from "@material-ui/icons/DateRangeOutlined";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import dayjs from "dayjs";
import styles from "../../ShiftDetailPage/ShiftDetail.module.scss";
import { getPaymentMethod, getPaymentTerms, getPaymentType } from "utils";
import { ShiftDetailsProps } from './index';
import { COUNTRY } from 'utils/constants';
import { Case, Show, Switch } from 'components/Conditionals';

export const ShiftDetails = React.memo(({ job, hourlyRate }: ShiftDetailsProps) => (
    <RightContainer>
        <Value>
            <DateRangeOutlinedIcon className={styles.shiftDateIcon} />
            {dayjs(job.shifts[0].shiftDate).format('dddd, MMM D')}
        </Value>
        <ValueBox>Start at: <Value>{job.shifts[0].postedStart}</Value></ValueBox>
        <ValueBox>Shift ends: <Value>{job.shifts[0].postedEnd}</Value></ValueBox>
        <ValueBox>Booked Rate: <Value>{hourlyRate}</Value></ValueBox>
        <ShiftBoxRateDescription>
            Office Pays: {getPaymentTerms(job.paymentTerms)} {job.paymentMethod ? `typically via ${getPaymentMethod(job.paymentMethod, job.location.country)}` : ''}
        </ShiftBoxRateDescription>
        <Show if={job.location.country === COUNTRY.US}>
            <ShiftBoxRateDescription> 
                Working Relationship:&nbsp;
                <Switch expression={job.paysW2}>
                    <Case value={0}>1099 Independent Contractor</Case>
                    <Case value={1}>W2</Case>
                    <Case value={2}><b>1099</b>&nbsp;or&nbsp;<b>W2</b>&nbsp;(you pick)</Case>
                </Switch>
                <a href="https://www.tempstars.com/1099-w2/" target="_system" className={"external"}>
                    <InfoOutlinedIcon sx={{ fontSize: 12 }} />
                </a>
            </ShiftBoxRateDescription>
        </Show>
        <DateTimeDescription>
            {`*start time is the time you are expected to be in the office, changed into your scrubs and ready to work, and is the start of paid time.`}
        </DateTimeDescription>
    </RightContainer>
)); 